module.exports = __webpack_public_path__ + "static/media/notbook.6079cbef.jpg";